export const reviews = [
  {
    id: 1,
    name: '김민지',
    age: '30대',
    ageColor: 'bg-green-100 text-green-700',
    avatarBg: 'bg-green-200',
    rating: 5,
    content: '대저토마토 가정용혼합 1kg 주문했는데 정말 신선해요! 짭짤하고 달콤한 맛이 독특해서 가족 모두 좋아해요. 산지직송이라 그런지 마트랑 비교가 안 돼요.',
  },
  {
    id: 2,
    name: '이준호',
    age: '50대',
    ageColor: 'bg-orange-100 text-orange-700',
    avatarBg: 'bg-orange-200',
    rating: 5,
    content: '부사사과 A급 5kg 주문했는데 하나하나 크고 아삭해요. 당도도 높고 과즙이 풍부해서 아이들이 너무 좋아해요. 다음에도 꼭 재구매할게요!',
  },
  {
    id: 3,
    name: '박서연',
    age: '20대',
    ageColor: 'bg-pink-100 text-pink-600',
    avatarBg: 'bg-pink-200',
    rating: 5,
    content: '천혜향 3kg 주문했는데 향이 집 안에 가득 퍼져요. 껍질도 얇고 씨도 없어서 먹기 너무 편해요. 친구한테도 선물했는데 엄청 좋아했어요!',
  },
  {
    id: 4,
    name: '최지우',
    age: '40대',
    ageColor: 'bg-amber-100 text-amber-700',
    avatarBg: 'bg-amber-200',
    rating: 5,
    content: '대저토마토 짭짤이 2.5kg 주문했어요. 일반 토마토랑 맛이 완전히 달라요. 짭짤하고 달콤한 독특한 풍미가 있어서 샐러드에 넣으면 최고예요.',
  },
  {
    id: 5,
    name: '정다은',
    age: '60대',
    ageColor: 'bg-red-100 text-red-700',
    avatarBg: 'bg-red-200',
    rating: 4,
    content: '카라향 중과 5kg 주문했는데 향이 정말 진하고 달아요. 껍질도 얇아서 벗기기 쉽고 씨도 없어서 너무 좋았어요. 제주산이라 그런지 맛이 달라요.',
  },
  {
    id: 6,
    name: '한승우',
    age: '20대',
    ageColor: 'bg-pink-100 text-pink-600',
    avatarBg: 'bg-pink-200',
    rating: 5,
    content: '주스용 사과 10kg 주문했는데 가격 대비 양이 엄청나요. 착즙기로 갈아 마시니까 진짜 맛있어요. 당도 높고 과즙 풍부해서 매일 아침 마시고 있어요.',
  },
  {
    id: 7,
    name: '오수빈',
    age: '50대',
    ageColor: 'bg-orange-100 text-orange-700',
    avatarBg: 'bg-orange-200',
    rating: 5,
    content: '금귤 특 2kg 주문했는데 알이 굵고 신선해요. 껍질째 먹으니까 달콤하고 새콤한 맛이 너무 좋아요. 비타민C 보충에 딱이에요. 재구매 확정!',
  },
  {
    id: 8,
    name: '윤재현',
    age: '30대',
    ageColor: 'bg-green-100 text-green-700',
    avatarBg: 'bg-green-200',
    rating: 5,
    content: '가정용 참외 로얄과 3kg 주문했는데 당도가 정말 높아요. 성주 참외 특유의 향과 맛이 살아있어서 너무 맛있어요. 꼭지도 싱싱하게 왔어요.',
  },
  {
    id: 9,
    name: '최유진',
    age: '40대',
    ageColor: 'bg-amber-100 text-amber-700',
    avatarBg: 'bg-amber-200',
    rating: 5,
    content: '못난이 참외 5kg 주문했는데 모양만 다르지 맛은 정품이랑 똑같아요! 가격도 훨씬 저렴해서 가성비 최고예요. 아이들 간식으로 딱이에요.',
  },
  {
    id: 10,
    name: '강민수',
    age: '60대',
    ageColor: 'bg-red-100 text-red-700',
    avatarBg: 'bg-red-200',
    rating: 5,
    content: '부사사과 B급 5kg 주문했는데 A급이랑 맛 차이가 없어요. 외관만 조금 다를 뿐 가성비 최고입니다! 매달 주문하고 있어요.',
  },
  {
    id: 11,
    name: '윤하영',
    age: '20대',
    ageColor: 'bg-pink-100 text-pink-600',
    avatarBg: 'bg-pink-200',
    rating: 5,
    content: '천혜향 5kg 주문했는데 하나도 상한 것 없이 다 싱싱하게 왔어요. 과즙이 풍부하고 씨가 없어서 먹기 편해요. 포장도 꼼꼼해서 감동받았어요.',
  },
  {
    id: 12,
    name: '박준혁',
    age: '50대',
    ageColor: 'bg-orange-100 text-orange-700',
    avatarBg: 'bg-orange-200',
    rating: 5,
    content: '대저토마토 가정용혼합 2.5kg 주문했는데 크기가 다양하게 섞여 있어서 좋아요. 라이코펜이 풍부하다고 해서 건강을 위해 매주 주문해요.',
  },
  {
    id: 13,
    name: '이소영',
    age: '30대',
    ageColor: 'bg-green-100 text-green-700',
    avatarBg: 'bg-green-200',
    rating: 5,
    content: '가정용 참외 로얄과 5kg 주문했는데 노란색이 선명하고 꼭지가 싱싱해요. 당도가 높아서 아이들이 너무 좋아해요. 성주 직송이라 믿을 수 있어요.',
  },
  {
    id: 14,
    name: '김태현',
    age: '40대',
    ageColor: 'bg-amber-100 text-amber-700',
    avatarBg: 'bg-amber-200',
    rating: 4,
    content: '금귤 특 3kg 주문했는데 크기가 균일하고 신선해요. 껍질째 통으로 먹으니까 플라보노이드도 풍부하고 맛도 좋아요. 아이들 간식으로 자주 줘요.',
  },
  {
    id: 15,
    name: '장미래',
    age: '60대',
    ageColor: 'bg-red-100 text-red-700',
    avatarBg: 'bg-red-200',
    rating: 5,
    content: '카라향 10kg 대량 주문했는데 가격도 합리적이고 품질도 최상이에요. 제주 서귀포산이라 향이 진하고 당도가 높아요. 지인들한테도 소개해줬어요.',
  },
  {
    id: 16,
    name: '신동욱',
    age: '20대',
    ageColor: 'bg-pink-100 text-pink-600',
    avatarBg: 'bg-pink-200',
    rating: 5,
    content: '부사사과 A급 2kg 주문했는데 냉장 보관하니까 신선도가 오래 유지돼요. 아삭하고 달콤한 맛이 최고예요. 폴리페놀이 풍부하다고 해서 매일 먹어요.',
  },
  {
    id: 17,
    name: '홍지연',
    age: '50대',
    ageColor: 'bg-orange-100 text-orange-700',
    avatarBg: 'bg-orange-200',
    rating: 5,
    content: '못난이 참외 10kg 대량 주문했는데 가격이 정말 착해요. 동네 분들이랑 나눠 먹었는데 다들 맛있다고 난리났어요. 모양만 다를 뿐 맛은 최고예요.',
  },
  {
    id: 18,
    name: '류성호',
    age: '30대',
    ageColor: 'bg-green-100 text-green-700',
    avatarBg: 'bg-green-200',
    rating: 5,
    content: '대저토마토 짭짤이 1kg 처음 주문해봤는데 완전히 새로운 맛이에요. 일반 토마토보다 당도가 높고 짭짤한 풍미가 독특해요. 이제 단골 됐어요.',
  },
  {
    id: 19,
    name: '정수현',
    age: '40대',
    ageColor: 'bg-amber-100 text-amber-700',
    avatarBg: 'bg-amber-200',
    rating: 5,
    content: '부모님께 천혜향 10kg 효도 선물로 보내드렸더니 너무 좋아하셨어요. 향이 진하고 달콤해서 어르신들이 특히 좋아하시더라고요.',
  },
  {
    id: 20,
    name: '한지훈',
    age: '60대',
    ageColor: 'bg-red-100 text-red-700',
    avatarBg: 'bg-red-200',
    rating: 5,
    content: '부사사과 쥬스용 5kg 주문해서 매일 착즙해 마시는데 건강이 좋아진 것 같아요. 가격도 저렴하고 양도 많아서 정말 만족해요.',
  },
  {
    id: 21,
    name: '오미선',
    age: '20대',
    ageColor: 'bg-pink-100 text-pink-600',
    avatarBg: 'bg-pink-200',
    rating: 4,
    content: '금귤 특 1kg 주문했는데 알이 굵고 향이 좋아요. 껍질째 먹으면 달콤하고 과육은 새콤해서 독특한 맛이에요. 비타민C 보충에 딱이에요.',
  },
  {
    id: 22,
    name: '배현숙',
    age: '50대',
    ageColor: 'bg-orange-100 text-orange-700',
    avatarBg: 'bg-orange-200',
    rating: 5,
    content: '가정용 참외 로얄과 2kg 주문했는데 수분이 90% 이상이라 그런지 정말 시원하고 달아요. 여름 과일로 최고예요. 매주 주문하고 있어요.',
  },
  {
    id: 23,
    name: '임재원',
    age: '30대',
    ageColor: 'bg-green-100 text-green-700',
    avatarBg: 'bg-green-200',
    rating: 5,
    content: '부사사과 B급 3kg 주문했는데 A급이랑 맛이 똑같아요. 외관만 조금 다를 뿐이고 아삭하고 달콤한 맛은 동일해요. 가성비 최고 상품이에요.',
  },
  {
    id: 24,
    name: '전미경',
    age: '40대',
    ageColor: 'bg-amber-100 text-amber-700',
    avatarBg: 'bg-amber-200',
    rating: 5,
    content: '명절 선물로 카라향 5kg 주문했는데 포장이 너무 고급스러워서 받는 분들이 다들 좋아하셨어요. 제주산이라 향도 진하고 맛도 최고예요.',
  },
  {
    id: 25,
    name: '조성민',
    age: '60대',
    ageColor: 'bg-red-100 text-red-700',
    avatarBg: 'bg-red-200',
    rating: 5,
    content: '대저토마토 가정용혼합 2.5kg 주문했는데 부산 대저동 산지직송이라 신선도가 달라요. 항산화 성분이 풍부하다고 해서 건강을 위해 매주 먹어요.',
  },
  {
    id: 26,
    name: '권나영',
    age: '20대',
    ageColor: 'bg-pink-100 text-pink-600',
    avatarBg: 'bg-pink-200',
    rating: 4,
    content: '못난이 참외 3kg 주문했는데 모양은 달라도 맛은 정말 최고예요! 성주 직송이라 당도가 높고 아삭해요. 가격도 저렴해서 자주 주문할 것 같아요.',
  },
  {
    id: 27,
    name: '문성준',
    age: '50대',
    ageColor: 'bg-orange-100 text-orange-700',
    avatarBg: 'bg-orange-200',
    rating: 5,
    content: '천혜향 2kg 주문했는데 향이 집 안에 가득 퍼져요. 냉장고 열면 향이 퍼질 정도예요. 과즙이 풍부하고 씨가 없어서 먹기 너무 편해요.',
  },
  {
    id: 28,
    name: '서지혜',
    age: '30대',
    ageColor: 'bg-green-100 text-green-700',
    avatarBg: 'bg-green-200',
    rating: 5,
    content: '부사사과 A급 1kg 주문했는데 주문하고 다음날 바로 왔어요. 경북 청송산이라 그런지 맛이 정말 달라요. 아삭하고 달콤해서 매일 먹고 있어요.',
  },
  {
    id: 29,
    name: '남궁철',
    age: '40대',
    ageColor: 'bg-amber-100 text-amber-700',
    avatarBg: 'bg-amber-200',
    rating: 5,
    content: '대저토마토 짭짤이 2.5kg 주문했는데 꼭지가 싱싱하고 껍질이 팽팽해요. 일반 토마토보다 당도가 훨씬 높아서 그냥 먹어도 맛있어요.',
  },
  {
    id: 30,
    name: '안혜진',
    age: '60대',
    ageColor: 'bg-red-100 text-red-700',
    avatarBg: 'bg-red-200',
    rating: 5,
    content: '금귤 특 5kg 주문했는데 알이 굵고 신선해요. 껍질째 통으로 먹으니까 달콤하고 새콤한 맛이 너무 좋아요. 칼슘도 풍부하다고 해서 매일 먹어요.',
  },
  {
    id: 31,
    name: '김영숙',
    age: '20대',
    ageColor: 'bg-pink-100 text-pink-600',
    avatarBg: 'bg-pink-200',
    rating: 5,
    content: '가정용 참외 로얄과 1kg 주문했는데 꼭지 부분이 싱싱하고 노란색이 선명해요. 달콤하고 아삭한 맛이 최고예요. 여름 내내 주문할 것 같아요.',
  },
  {
    id: 32,
    name: '이철수',
    age: '50대',
    ageColor: 'bg-orange-100 text-orange-700',
    avatarBg: 'bg-orange-200',
    rating: 5,
    content: '부사사과 쥬스용 3kg 주문해서 착즙기로 갈아 마시는데 당도가 높고 과즙이 풍부해요. 건강 관리에 딱이에요. 가격도 합리적이에요.',
  },
  {
    id: 33,
    name: '박경희',
    age: '30대',
    ageColor: 'bg-green-100 text-green-700',
    avatarBg: 'bg-green-200',
    rating: 5,
    content: '카라향 중과 3kg 선물용으로 주문했는데 포장이 고급스러워서 받는 분들이 항상 좋아하세요. 제주 서귀포산이라 향이 진하고 달콤해요.',
  },
  {
    id: 34,
    name: '조명환',
    age: '40대',
    ageColor: 'bg-amber-100 text-amber-700',
    avatarBg: 'bg-amber-200',
    rating: 5,
    content: '당뇨가 있어서 과일 선택이 중요한데 대저토마토 가정용혼합 추천받았어요. 라이코펜과 비타민C가 풍부해서 건강에도 좋고 맛도 있어요.',
  },
  {
    id: 35,
    name: '신혜정',
    age: '60대',
    ageColor: 'bg-red-100 text-red-700',
    avatarBg: 'bg-red-200',
    rating: 4,
    content: '못난이 참외 2kg 주문했는데 모양만 다를 뿐 맛과 영양은 정품과 동일해요. 엽산과 칼륨이 풍부하다고 해서 건강을 위해 자주 먹어요.',
  },
  {
    id: 36,
    name: '최병호',
    age: '20대',
    ageColor: 'bg-pink-100 text-pink-600',
    avatarBg: 'bg-pink-200',
    rating: 5,
    content: '부사사과 B급 2kg 주문했는데 아내가 너무 좋아해서 매달 주문하기로 했어요. A급이랑 맛 차이가 없고 가격은 훨씬 저렴해서 가성비 최고예요.',
  },
  {
    id: 37,
    name: '강순희',
    age: '50대',
    ageColor: 'bg-orange-100 text-orange-700',
    avatarBg: 'bg-orange-200',
    rating: 5,
    content: '천혜향 10kg 주문했는데 껍질이 얇고 향이 강한 것들로 왔어요. 과즙이 풍부하고 씨가 없어서 먹기 편해요. 베타카로틴도 풍부하다고 해서 좋아요.',
  },
  {
    id: 38,
    name: '윤기태',
    age: '30대',
    ageColor: 'bg-green-100 text-green-700',
    avatarBg: 'bg-green-200',
    rating: 5,
    content: '카카오톡으로 주문하는 방식이 처음엔 낯설었는데 너무 편해요. 카라향 중과 2kg 주문했는데 빠른 답변에 당일 배송까지 완벽했어요.',
  },
  {
    id: 39,
    name: '임순자',
    age: '40대',
    ageColor: 'bg-amber-100 text-amber-700',
    avatarBg: 'bg-amber-200',
    rating: 5,
    content: '금귤 특 2kg 주문했는데 알이 굵고 신선해요. 비타민C가 풍부하다고 해서 매일 먹고 있어요. 피부도 좋아진 것 같고 면역력도 올라간 것 같아요.',
  },
  {
    id: 40,
    name: '박재만',
    age: '60대',
    ageColor: 'bg-red-100 text-red-700',
    avatarBg: 'bg-red-200',
    rating: 5,
    content: '가정용 참외 로얄과 5kg 주문했는데 가격이 정말 착해요. 동네 분들이랑 나눠 먹었는데 다들 맛있다고 난리났어요. 성주 직송이라 믿을 수 있어요.',
  },
  {
    id: 41,
    name: '한미숙',
    age: '20대',
    ageColor: 'bg-pink-100 text-pink-600',
    avatarBg: 'bg-pink-200',
    rating: 4,
    content: '대저토마토 짭짤이 1kg 처음 먹어봤는데 이게 토마토 맞나 싶을 정도로 맛있어요. 짭짤하고 달콤한 독특한 맛에 완전히 빠졌어요. 재구매 확정!',
  },
  {
    id: 42,
    name: '송영철',
    age: '50대',
    ageColor: 'bg-orange-100 text-orange-700',
    avatarBg: 'bg-orange-200',
    rating: 5,
    content: '부사사과 쥬스용 10kg 주문했는데 산지직송이라 중간 유통 과정이 없어서 더 신선해요. 착즙하면 달콤하고 과즙이 풍부해서 매일 마시고 있어요.',
  },
  {
    id: 43,
    name: '정명자',
    age: '30대',
    ageColor: 'bg-green-100 text-green-700',
    avatarBg: 'bg-green-200',
    rating: 5,
    content: '부모님 생신 선물로 천혜향 5kg 보냈는데 너무 좋아하셨어요. 포장도 예쁘고 향이 진하고 달콤하다고 하셨어요. 매년 생신 선물로 주문할게요.',
  },
  {
    id: 44,
    name: '오창수',
    age: '40대',
    ageColor: 'bg-amber-100 text-amber-700',
    avatarBg: 'bg-amber-200',
    rating: 5,
    content: '못난이 참외 1kg 주문해봤는데 모양은 달라도 맛은 정말 최고예요. 수분이 90% 이상이라 시원하고 달아요. 가성비 최고 상품이에요.',
  },
  {
    id: 45,
    name: '류미화',
    age: '60대',
    ageColor: 'bg-red-100 text-red-700',
    avatarBg: 'bg-red-200',
    rating: 5,
    content: '카라향 중과 5kg 주문했는데 향이 정말 진해요. 냉장고 열면 향이 퍼질 정도예요. 헤스페리딘이 풍부하다고 해서 건강을 위해 매일 먹어요.',
  },
  {
    id: 46,
    name: '황순자',
    age: '20대',
    ageColor: 'bg-pink-100 text-pink-600',
    avatarBg: 'bg-pink-200',
    rating: 5,
    content: '부사사과 A급 3kg 주문했는데 경북 청송산이라 그런지 맛이 달라요. 아삭하고 달콤한 맛에 과즙도 풍부해요. 냉장 보관하니까 신선도도 오래 유지돼요.',
  },
  {
    id: 47,
    name: '김봉수',
    age: '50대',
    ageColor: 'bg-orange-100 text-orange-700',
    avatarBg: 'bg-orange-200',
    rating: 5,
    content: '노인정에서 단체로 금귤 특 5kg 주문했는데 어르신들이 다들 맛있다고 좋아하셨어요. 껍질째 먹으니까 편하고 달콤해서 인기 최고였어요.',
  },
  {
    id: 48,
    name: '이정순',
    age: '30대',
    ageColor: 'bg-green-100 text-green-700',
    avatarBg: 'bg-green-200',
    rating: 5,
    content: '천혜향이 이렇게 맛있는 줄 몰랐어요. 씨도 없고 껍질도 얇아서 먹기 편해요. 제주 서귀포산이라 향이 진하고 달콤해요. 매년 시즌마다 주문할게요.',
  },
  {
    id: 49,
    name: '박종길',
    age: '40대',
    ageColor: 'bg-amber-100 text-amber-700',
    avatarBg: 'bg-amber-200',
    rating: 4,
    content: '부사사과 B급 2kg 주문했는데 아삭하고 달아요. 예전에 시골에서 먹던 사과 맛이 나서 추억이 새록새록해요. 외관만 다를 뿐 맛은 A급이랑 똑같아요.',
  },
  {
    id: 50,
    name: '최순례',
    age: '60대',
    ageColor: 'bg-red-100 text-red-700',
    avatarBg: 'bg-red-200',
    rating: 5,
    content: '대저토마토 가정용혼합 1kg 주문했는데 부산 대저동 산지직송이라 신선도가 달라요. 상온 보관하니까 맛이 더 좋아요. 사장님도 친절하게 안내해주셨어요.',
  },
];
